import { render, staticRenderFns } from "./SalesOrdersList.vue?vue&type=template&id=4755b18b&"
import script from "./SalesOrdersList.vue?vue&type=script&lang=js&"
export * from "./SalesOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrdersList.vue?vue&type=style&index=0&id=4755b18b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports